module.exports = __webpack_public_path__ + "d0d6a6d79daa87c6da95872fda62593e.svg";